<div class="@container block">
  <div class="grid grid-cols-1 @sm:grid-cols-2 gap-3" uiPopover [anchor]="calendarPopover">
    <ui-input-label>
      <ng-content select="[slot=start-label]" />
      <ui-input-simple
        type="text"
        [placeholder]="placeholderStart()"
        (focusInput)="onTriggerShowCalendarPopover(calendarPopover)"
        (focus)="onTriggerShowCalendarPopover(calendarPopover)"
        (click)="onTriggerShowCalendarPopover(calendarPopover)"
        [disabled]="disabled()"
        [value]="field.start().value() | date: 'dd.MM.yyyy'"
        (change)="onChangeStart($event)"
      >
        <ng-icon slot="start" name="heroCalendar" size="20" class="!block" />
        @if (field.start().value()) {
          <ui-button
            slot="end"
            type="button"
            class="-mr-1.5"
            mode="ghost"
            size="small"
            [iconOnly]="true"
            (click)="onClickClearStart()"
          >
            <ng-icon name="heroXMark" size="20" class="!block" />
          </ui-button>
        }
      </ui-input-simple>
      <div class="empty:hidden" slot="bottom">
        <ng-content select="[slot=start-bottom]" />
      </div>
    </ui-input-label>
    <ui-input-label>
      <ng-content select="[slot=end-label]" />
      <ui-input-simple
        type="text"
        [placeholder]="placeholderEnd()"
        (focusInput)="onTriggerShowCalendarPopover(calendarPopover)"
        (focus)="onTriggerShowCalendarPopover(calendarPopover)"
        (click)="onTriggerShowCalendarPopover(calendarPopover)"
        [disabled]="disabled()"
        [value]="field.end().value() | date: 'dd.MM.yyyy'"
        (change)="onChangeEnd($event)"
      >
        <ng-icon slot="start" name="heroCalendar" size="20" class="!block" />
        @if (field.end().value()) {
          <ui-button
            slot="end"
            type="button"
            class="-mr-1.5"
            mode="ghost"
            size="small"
            [iconOnly]="true"
            (click)="onClickClearEnd()"
          >
            <ng-icon name="heroXMark" size="20" class="!block" />
          </ui-button>
        }
      </ui-input-simple>
      <div class="empty:hidden" slot="bottom">
        <ng-content select="[slot=end-bottom]" />
      </div>
    </ui-input-label>
  </div>
</div>
<ui-popover popover #calendarPopover>
  <div
    class="rounded-lg shadow-md bg-surface dark:bg-surface-darkmode border border-outline dark:border-outline-darkmode text-on-surface dark:text-on-surface-darkmode"
  >
    <ui-calendar-range-input
      [formField]="field"
      (fieldValueChange)="fieldValueChange.emit($event)"
    />
  </div>
</ui-popover>
